import React from 'react';

const InputWrapper = ({ labelTitle, children }) => {
	return (
		<div className="single-flied-item">
			<div className="form-group">
				<label htmlFor="collection">{labelTitle}</label>
				{children}
			</div>
		</div>
	);
};

export default InputWrapper;
